import Address from './Address'
import Contact from './Contact'
import NoW9 from './NoW9'
import Rewards from './Rewards'
import Settings from './Settings'
import WithW9 from './WithW9'

export { Address, Contact, NoW9, Rewards, Settings, WithW9 }
export default { Address, Contact, NoW9, Rewards, Settings, WithW9 }